import './lib'
import {baseStyle, Stripe} from './stripeElements'
import StripeElement from './StripeElement.vue'
import Card from './Card.vue'
import CardExpiry from './CardExpiry.vue'
import CardCvc from './CardCvc.vue'
import CardNumber from './CardNumber.vue'
import PostalCode from './PostalCode.vue'

export default {
    Card,
    CardNumber,
    CardExpiry,
    CardCvc,
    PostalCode,
    StripeElement,
    baseStyle,
    get instance() {
        return Stripe.instance;
    },
    get createToken() {
        return Stripe.createToken;
    },
    get createSource() {
        return Stripe.createSource;
    },
    get retrieveSource() {
        return Stripe.retrieveSource;
    },
    get paymentRequest() {
        return Stripe.paymentRequest;
    },
    get redirectToCheckout() {
        return Stripe.redirectToCheckout;
    },
    get retrievePaymentIntent() {
        return Stripe.retrievePaymentIntent;
    },
    get handleCardPayment() {
        return Stripe.handleCardPayment;
    },
    get handleCardSetup() {
        return Stripe.handleCardSetup;
    },
    get confirmPaymentIntent() {
        return Stripe.confirmPaymentIntent;
    },
    get createPaymentMethod() {
        return Stripe.createPaymentMethod;
    },
};
